import apiClient from './api-client';
import { API_ENDPOINTS } from '../../constants/api.constants';
import { AuthResponse, LoginCredentials, SignupCredentials } from '../../types';

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiClient.post(API_ENDPOINTS.LOGIN, credentials);
    return response.data.data;
  },

  async signup(credentials: SignupCredentials): Promise<AuthResponse> {
    const { profileImage, ...data } = credentials;

    if (profileImage) {
      const formData = new FormData();
      formData.append('firstName', data.firstName);
      formData.append('lastName', data.lastName);
      formData.append('email', data.email);
      formData.append('password', data.password);
      formData.append('profileImage', profileImage);
      if (data.campus) formData.append('campus', data.campus);
      if (data.zone) formData.append('zone', data.zone);
      if (data.phoneNumber) formData.append('phoneNumber', data.phoneNumber);

      const response = await apiClient.post(API_ENDPOINTS.SIGNUP, formData, {
        headers: {
          // Let browser set Content-Type automatically for FormData
        },
      });
      return response.data.data;
    }

    const response = await apiClient.post(API_ENDPOINTS.SIGNUP, data);
    return response.data.data;
  },

  async refreshToken(refreshToken: string): Promise<AuthResponse> {
    const response = await apiClient.post(API_ENDPOINTS.REFRESH, { refreshToken });
    return response.data.data;
  },

  async getProfile() {
    const response = await apiClient.get(API_ENDPOINTS.PROFILE);
    return response.data.data;
  },

  async updateProfile(data: {
    profileImage?: File;
    firstName?: string;
    lastName?: string;
    campus?: string;
    zone?: string;
    title?: string;
    phoneNumber?: string;
  }) {
    const formData = new FormData();
    if (data.profileImage) {
      formData.append('profileImage', data.profileImage);
    }
    if (data.firstName) {
      formData.append('firstName', data.firstName);
    }
    if (data.lastName) {
      formData.append('lastName', data.lastName);
    }
    if (data.campus !== undefined) {
      formData.append('campus', data.campus);
    }
    if (data.zone !== undefined) {
      formData.append('zone', data.zone);
    }
    if (data.title !== undefined) {
      formData.append('title', data.title);
    }
    if (data.phoneNumber !== undefined) {
      formData.append('phoneNumber', data.phoneNumber);
    }
    const response = await apiClient.patch(API_ENDPOINTS.PROFILE, formData, {
      headers: {
        // Let browser set Content-Type automatically for FormData
      },
    });
    return response.data.data;
  },

  logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  },

  async changePassword(currentPassword: string, newPassword: string) {
    const response = await apiClient.patch(API_ENDPOINTS.CHANGE_PASSWORD, {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  async deleteAccount(password: string) {
    const response = await apiClient.delete(API_ENDPOINTS.DELETE_ACCOUNT, {
      data: { password },
    });
    return response.data;
  },
};
